import script from "./WorkDurationInput.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkDurationInput.vue?vue&type=script&setup=true&lang=js"

import "./WorkDurationInput.vue?vue&type=style&index=0&id=c7812278&scoped=true&lang=css"

import exportComponent from "D:\\Programs\\Vue\\frame2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7812278"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput});
